import React from "react";
import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
    const error = useRouteError() as Error;

    return (
        <div className="row">
            <div className="col text-center top-container">
                <p className={'m-5'}>
                    <img src="/images/logo.svg"  style={{width: '250px'}} alt=""/>
                </p>
                <div className="card">
                    <div className="card-body">
                        <p className="d-none d-lg-block">&nbsp;</p>
                        <h3 className="py-4">Что-то пошло не так.</h3>
                        <p>Мы уже занимаемся решением возникшей проблемы.</p>
                        <p className={'text-muted mt-3'}>Error: <i>{error?.message}</i></p>
                        <p>&nbsp;</p>
                    </div>
                </div>
            </div>
        </div>
    )
}